/** Format a non-negative decimal token amount for display without rounding up. */
export function formatTokenAmount(value: string): string {
  const match = /^(\d+)(?:\.(\d+))?$/.exec(value);
  if (!match) return "—";

  const whole = match[1]!.replace(/^0+(?=\d)/, "");
  const fraction = match[2] ?? "";
  const displayedFraction = fraction.slice(0, 6).replace(/0+$/, "");
  if (whole === "0" && !displayedFraction && /[1-9]/.test(fraction)) return "< 0.000001";
  return `${whole}${displayedFraction ? `.${displayedFraction}` : ""}`;
}
